import React, { useEffect, useState } from "react";
import client from "../client/client";

import InputFile from "../InputFile/InputFile";
import InputTextarea from "../InputTextarea/InputTextarea";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import PrewButton from "../PrewButton/PrewButton";
import FinishButton from "../FinishButton/FinishButton";

function Step1(props) {
  const {
    setStep,
    participationType,
    name,
    surname,
    email,
    phone,
    telegram,

    city,
    place,
    haveIp,
    inn,
    specialization,
    expiration,
    portfolio,
    format,
    command,

    position,
    companyName,
    legalName,
    special,
    otherSpecial,
    ogrn,
    site,
    companyExpiration,
    comapanyCommand,
    addMaterials,

    solution,
    setSolution,
    uniqSolution,
    setUniqSolution,
    tools,
    setTools,
    results,
    setResults,
    sources,
    setSources,
    budget,
    setBudget,
    presentation,
    setPresentation,
    materials,
    setMaterials,

    task,
    agree,
    setAgree,
    dataAgreement,
  } = props;

  const [isFormFilled, setIsFormFilled] = useState(false);
  const [formErrors, setFormErrors] = useState(null);

  const submitHandler = (event) => {
    event.preventDefault();

    let url;
    let data;

    if (participationType === "1") {
      url = `/full_individual/`;

      let ip = haveIp === "1" ? true : false;

      data = {
        name: name,
        f_name: surname,
        email: email,
        phone: phone,
        telegram: telegram,
        participation: dataAgreement,
        city: city,
        place: place,
        have_ip: ip,
        inn: inn,
        specialization: specialization,
        expiration: expiration,
        portfolio: portfolio,
        format: format,
        command: command,
        solution: solution,
        uniq_solution: uniqSolution,
        tools: tools,
        results: results,
        sources: sources,
        budget: budget,
        presentation: presentation,
        materials: materials,
        agree: agree,
        tasks: task,
      };
    }

    if (participationType === "2") {
      url = `/full_command/`;
      data = {
        name: name,
        f_name: surname,
        email: email,
        phone: phone,
        telegram: telegram,
        participation: dataAgreement,
        position: position,
        company_name: companyName,
        legal_name: legalName,
        special: special.value,
        other_special: otherSpecial,
        ogrn: ogrn,
        site: site,
        expiration: companyExpiration,
        command: comapanyCommand,
        add_materials: addMaterials,
        solution: solution,
        uniq_solution: uniqSolution,
        tools: tools,
        results: results,
        sources: sources,
        budget: budget,
        presentation: presentation,
        materials: materials,
        agree: agree,
        tasks: task,
      };
    }

    client
      .post(url, data)
      .then((res) => {
        setStep(7);
      })
      .catch((error) => {
        console.log(error);
        if (error.response?.status === 400) {
          setFormErrors(error.response.data);
        }
      });
  };

  useEffect(() => {
    setIsFormFilled(
      solution &&
        uniqSolution &&
        tools &&
        results &&
        sources &&
        budget &&
        presentation &&
        agree
    );
    // setIsFormFilled(true);
  }, [
    solution,
    uniqSolution,
    tools,
    results,
    sources,
    budget,
    presentation,
    agree,
  ]);

  useEffect(() => {
    if (formErrors) {
      const firstError = Object.keys(formErrors)[0];
      const firstErrorInput = document.querySelector(`[name=${firstError}]`);

      firstErrorInput.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  }, [formErrors]);

  return (
    <form action="." onSubmit={submitHandler}>
      <div className="mm-form__inner">
        <InputTextarea
          title="Кратко опишите предлагаемое решение *"
          placeholder="Объем текста не должен превышать 1500 символов"
          maxlength={1500}
          value={solution}
          onChange={setSolution}
          error={formErrors?.solution}
          name="solution"
        />
        <InputTextarea
          title="Обоснуйте уникальность решения *"
          placeholder="Объем текста не должен превышать 1000 символов"
          maxlength={1000}
          value={uniqSolution}
          onChange={setUniqSolution}
          error={formErrors?.uniqSolution}
          name="uniqSolution"
        />
        <InputTextarea
          title="Укажите предлагаемые инструменты *"
          placeholder="Объем текста не должен превышать 1000 символов"
          maxlength={1000}
          value={tools}
          onChange={setTools}
          error={formErrors?.tools}
          name="tools"
        />
        <InputTextarea
          title="Опишите ожидаемые результаты *"
          placeholder="Объем текста не должен превышать 1000 символов"
          maxlength={1000}
          value={results}
          onChange={setResults}
          error={formErrors?.results}
          name="results"
        />
        <InputTextarea
          title="Какие ресурсы потребуются для реализации решения *"
          placeholder="Объем текста не должен превышать 1000 символов"
          maxlength={1000}
          value={sources}
          onChange={setSources}
          error={formErrors?.sources}
          name="sources"
        />
        <InputTextarea
          title="Обозначьте возможный бюджет проекта *"
          placeholder="Объем текста не должен превышать 1000 символов"
          maxlength={1000}
          value={budget}
          onChange={setBudget}
          error={formErrors?.budget}
          name="budget"
        />
        <InputFile
          title="Прикрепите презентацию решения *"
          subTitle="Форматы .pptx, .pdf, объем не менее 20 стр., размер файла не должен превышать 25 МБ"
          placeholder="Загрузите файл или ссылку на Яндекс.Диск"
          value={presentation}
          onChange={setPresentation}
          error={formErrors?.presentation}
          name="presentation"
        />
        <InputFile
          title="Прикрепите дополнительные материалы"
          subTitle="Форматы .jpg, .png, .doc, .docx, .pptx, .pdf, размер файла не должен превышать 25 МБ"
          placeholder="Загрузите файл или ссылку на Яндекс.Диск"
          value={materials}
          onChange={setMaterials}
          error={formErrors?.materials}
          name="materials"
        />
        <InputCheckbox
          title="Я внимательно прочитал и соглашаюсь с <a href='https://create.travelhub.moscow/statement' target='_blank'>Положением о проведении конкурса</a>"
          value={agree}
          onChange={setAgree}
          name="agree"
        />
      </div>

      <div className="buttons-wrapper">
        <PrewButton
          onClick={() => {
            setStep(4);
          }}
        />
        <FinishButton
          type="submit"
          disabled={!isFormFilled}
          text="Подать заявку"
        />
      </div>
    </form>
  );
}

export default Step1;
